import { ValidatorInterface } from "./ValidatorInterface";
import { AbstractValidator, ValidatorObject } from "./AbstractValidator";
import { countDecimals } from "@/functions/numbers";
import {sprintf} from 'sprintf-js';

interface DecimalPointsValidatorObject extends ValidatorObject {
	decimalPoints?: number;
	value?: number|string;
}

/**
 * Validator that checks for decimal points
 */
export class MaximumDecimalPoints extends AbstractValidator implements ValidatorInterface {
	declare readonly value: number;
	private readonly decimalPoints: number;

	/**
	 * Constructor.
	 *
	 * @param {DecimalPointsValidatorObject} options
	 */
	constructor( options: DecimalPointsValidatorObject ) {
		super( options );

		const value = options.value ?? this.getDimensionValue();

		if ( typeof value !== 'number' ) {
			throw new Error( 'The MaximumDecimalPoints validator can only be used on numbers.' );
		}

		this.value = value;
		this.decimalPoints = options.decimalPoints ?? 1;
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		if ( super.getCustomMessage() ) {
			return super.getCustomMessage();
		}

		const { dimensions } = this.getValidatorTranslationStrings();

		return sprintf( dimensions.decimals, this.getDimensionLabel(), this.decimalPoints, 'cm' );
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		return countDecimals( this.value ) <= this.decimalPoints;
	}
}
